import { espaceDe } from './apparence';

/**
 * Une section sombre de panneaux : « l'exemple en trois temps ».
 *
 * Chaque panneau porte une étiquette en capitales, une grande valeur et un
 * texte. Les valeurs sont du TEXTE (« 90,00 € », « Bruno → Alice »), pour
 * rester traduisibles. Le fond sombre isole l'exemple du reste de la page :
 * c'est ce qui le rend lisible d'un coup d'œil.
 */
const SectionSombreBloc = ({ bloc }) => {
    const panneaux = Array.isArray(bloc?.panneaux) ? bloc.panneaux : [];
    if (!bloc?.titre && panneaux.length === 0) return null;

    return (
        <section
            className={`${espaceDe(bloc.espace, 'mb-10')} rounded-3xl bg-slate-900 text-white px-6 py-8 md:px-10 md:py-10`}
            data-testid="bloc-sectionSombre"
        >
            {bloc.badge && (
                <span className="inline-block px-3 py-1 rounded-full bg-teal-900 text-teal-200 text-xs font-semibold tracking-wide mb-3">
                    {bloc.badge}
                </span>
            )}
            {bloc.titre && <h2 className="text-2xl md:text-3xl font-bold">{bloc.titre}</h2>}
            {bloc.sousTitre && <p className="text-slate-300 mt-2 max-w-2xl">{bloc.sousTitre}</p>}

            {panneaux.length > 0 && (
                <div className="grid gap-4 mt-6 md:grid-cols-3">
                    {panneaux.map((p, i) => (
                        <div key={i} className="rounded-2xl bg-slate-800 p-5">
                            {p.etiquette && (
                                <p className="text-xs font-semibold tracking-wide text-slate-400 uppercase">{p.etiquette}</p>
                            )}
                            {p.valeur && (
                                <p className="text-3xl font-bold my-2 tabular-nums">{p.valeur}</p>
                            )}
                            {p.texte && <p className="text-sm text-slate-300">{p.texte}</p>}
                        </div>
                    ))}
                </div>
            )}
        </section>
    );
};

export default SectionSombreBloc;
